var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7502 36.25C28.7502 33.2663 29.9354 30.4048 32.0452 28.295C34.155 26.1853 37.0165 25 40.0002 25C42.9839 25 45.8454 26.1853 47.9551 28.295C50.0649 30.4048 51.2502 33.2663 51.2502 36.25V41.0087L53.6602 47.0362C53.7359 47.2258 53.7641 47.4311 53.7422 47.6341C53.7203 47.8371 53.649 48.0316 53.5346 48.2007C53.4201 48.3697 53.266 48.5082 53.0857 48.604C52.9054 48.6997 52.7043 48.7499 52.5002 48.75H27.5002C27.296 48.7499 27.095 48.6997 26.9147 48.604C26.7344 48.5082 26.5803 48.3697 26.4658 48.2007C26.3514 48.0316 26.2801 47.8371 26.2582 47.6341C26.2363 47.4311 26.2644 47.2258 26.3402 47.0362L28.7502 41.0087V36.25ZM35.1564 51.25C35.4317 52.3248 36.0575 53.2771 36.9348 53.9562C37.812 54.6354 38.8907 55.0027 40.0002 55C41.1096 55.0027 42.1883 54.6354 43.0656 53.9562C43.9429 53.2771 44.5687 52.3248 44.8439 51.25H35.1564Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 26.4625,
    y1: 40,
    x2: 53.5353,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CA50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/notif-icon.55e6765d1d89c784f25140206536a623.svg";
export { ForwardRef as ReactComponent };